'use client'

import { RegisterDeliveryInformationFormValues } from '@features/delivery/model'
import { useTranslation } from '@shared/config/i18n'
import { KAKAO_POSTCODE_SCRIPT_URL } from '@shared/constants/external-urls'
import { SafeAreaView, TopBackNavigation, TopStickyContainer } from '@shared/ui'
import { useEffect } from 'react'
import { DaumPostcodeEmbed } from 'react-daum-postcode'

type Props = {
  handleChange: (name: keyof RegisterDeliveryInformationFormValues, value: string) => void
  close: () => void
}

const PostcodePopUp = ({ handleChange, close }: Props) => {
  const t = useTranslation()

  // 팝업이 열릴 때 body 스크롤 방지
  useEffect(() => {
    // 원래 스크롤 위치 저장
    const scrollY = window.scrollY

    // body에 스크롤 방지 스타일 적용
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollY}px`
    document.body.style.width = '100%'
    document.body.style.overflow = 'hidden'

    // 컴포넌트 언마운트 시 스크롤 복원
    return () => {
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      document.body.style.overflow = ''
      window.scrollTo(0, scrollY)
    }
  }, [])

  return (
    <SafeAreaView className="fixed inset-0 z-50 bg-white">
      <TopStickyContainer>
        <TopBackNavigation backButtonAction={close} title={t('delivery.form.searchAddress')} />
      </TopStickyContainer>

      <DaumPostcodeEmbed
        className="flex-1 mt-[var(--safe-area-inset-top)]"
        scriptUrl={KAKAO_POSTCODE_SCRIPT_URL}
        onComplete={(data) => {
          handleChange('zipCode', data.zonecode)
          handleChange('address', data.address)

          close()
        }}
      />
    </SafeAreaView>
  )
}

export default PostcodePopUp
